<template>
  <div
    class="full-screen-video"
    :style="{ display: show ? '' : 'none' }"
    :class="closeDown ? 'full-screen-video-close-down' : ''"
  >
    <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg" @click="close">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 48a24 24 0 100-48 24 24 0 000 48zm-7.3-31.3a1 1 0 011.42 0l5.66 5.66 5.65-5.65a1 1 0 011.42 1.41l-5.66 5.66 5.66 5.65a1 1 0 01-1.41 1.42l-5.66-5.66-5.66 5.66a1 1 0 11-1.41-1.42l5.65-5.65-5.65-5.66a1 1 0 010-1.41z"
        fill="#fff"
      />
    </svg>
    <video
      ref="video"
      :key="src"
      :preload="preload"
      :controls="controls"
      x5-playsinline
      :playsinline="playsinline"
      webkit-playsinline
      x-webkit-airplay="allow"
      :poster="poster"
      :autoplay="autoplay"
      :muted="muted"
      :loop="loop"
      :style="{
        width: width,
        heigth: height
      }"
    >
      <source :src="src" type="video/mp4" />
    </video>
  </div>
</template>
<script>
export default {
  inject: ['vm'],
  data() {
    return {
      show: false,
      closeDown: false,
      src: undefined,
      width: '100%',
      height: 'auto',
      poster: undefined,
      preload: 'meta',
      controls: undefined,
      playsinline: undefined,
      autoplay: true,
      muted: true,
      loop: false
    };
  },
  mounted() {
    this.vm.setFullScreenVideo(this);
  },
  methods: {
    close() {
      this.$refs.video.pause();
      this.closeDown = true;
      if (this.closeTimer) clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        this.show = false;
      }, 600);
    },
    open({
      src,
      width = '100%',
      height,
      poster = '',
      preload = 'meta',
      controls = '',
      playsinline = '',
      autoplay = true,
      muted = true,
      loop = false
    }) {
      this.src = src;
      this.width = width;
      this.height = height;
      this.poster = poster;
      this.preload = preload;
      this.controls = controls;
      this.autoplay = autoplay;
      this.muted = muted;
      this.loop = loop;
      this.playsinline = playsinline;
      this.show = true;
      this.closeDown = false;
      setTimeout(() => {
        this.$refs.video.play();
      }, 10);
    }
  }
};
</script>
<style lang="scss">
.full-screen-video {
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  height: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  animation: 0.8s fadeInUp cubic-bezier(0.3, 0, 0.1, 1);
  svg {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 48px;
    height: 48px;
  }
  video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    object-fit: fill;
  }
}
.full-screen-video-close-down {
  animation-name: fadeInDown;
  animation-fill-mode: forwards;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(50px);
  }
}
@media screen and (max-width: 734px) {
  .full-screen-video-close-down video {
    /* display: none; */
  }
}
</style>
